import { render, staticRenderFns } from "./GdprInfo.vue?vue&type=template&id=3a9e10fe&scoped=true&"
var script = {}
import style0 from "./GdprInfo.vue?vue&type=style&index=0&id=3a9e10fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e10fe",
  null
  
)

export default component.exports